<script setup lang="ts">
import { computed } from "vue";

import DropdownFloating from "@/components/DropdownFloating.vue";
import Icon from "@/components/Icon.vue";
import { useAccount } from "@/composables/useAccount";
import { authState } from "@/constants/plugins/auth";
import type { NavigationItem } from "@/types";

const accountQuery = useAccount();

await accountQuery.suspense();

const account = computed(() => accountQuery.data.value);

const isAdmin = computed(() => authState.isAdmin);

const menuForAuthUser = computed<Array<NavigationItem>>(() => {
  const menu: Array<NavigationItem> = [];

  menu.push({
    key: "profile",
    to: { name: "Profile" },
    name: "Profile",
    icon: { name: "person", type: "filled" },
  });

  menu.push({
    key: "logout",
    to: { name: "AuthLogout" },
    name: "Sign out",
    icon: { name: "logout", type: "outlined" },
  });

  return menu;
});
</script>

<template>
  <DropdownFloating
    class="relative inline-block w-full! max-w-full"
    placement="auto-end"
    :menu="menuForAuthUser"
  >
    <template #header>
      <div class="flex items-center border-b border-gray-300 p-4">
        <div class="ml-3 text-xs">
          <div class="font-semibold">
            {{ account?.name?.trim() ? account?.name : (account?.displayName ?? "-") }}
          </div>
          <div>{{ account?.email }}</div>
        </div>
      </div>
    </template>
    <template #button>
      <button
        :class="`relative group w-full py-2 text-left text-sm font-medium text-white focus:outline-hidden lg:rounded-lg lg:bg-gray-800 lg:px-2 lg:hover:bg-gray-700 ${isAdmin && 'rounded-t-none!'}`"
        type="button"
      >
        <span class="flex w-full items-center justify-center lg:justify-between">
          <span class="flex min-w-0 items-center justify-between space-x-3">
            <div class="relative flex">
              <!-- <img
                v-if="account?.picture"
                :src="account?.picture"
                class="h-6 w-6 shrink-0 lg:h-10 lg:w-10"
                aria-label="Your avatar"
              /> -->
            </div>
            <span class="hidden min-w-0 flex-1 flex-col lg:flex">
              <span class="truncate text-sm text-gray-400">
                {{ account?.name?.trim() ? account?.name : (account?.displayName ?? "-") }}
              </span>
              <span class="truncate text-sm font-medium text-white">
                {{ account?.email }}
              </span>
            </span>
          </span>
          <Icon
            name="unfold"
            class="hidden h-5 w-5 shrink-0 text-gray-400 group-hover:text-gray-500 lg:inline-block"
            aria-hidden="true"
          />
        </span>
      </button>
      <div
        v-if="isAdmin"
        class="absolute -top-6 inset-x-0 h-6 flex items-center justify-center px-2 rounded-t bg-red-500 text-red-200 text-xs font-semibold"
      >
        Admin
      </div>
    </template>
  </DropdownFloating>
</template>
